export const sortParametersDataWithFixedOrder = (obj: Record<string, any>, fixedOrder: string[]): Record<string, any> => {
  const sortedObj: Record<string, any> = {};
  const remainingKeys = Object.keys(obj).filter((key) => !fixedOrder.includes(key));

  fixedOrder.forEach((key) => {
    if (obj[key] !== undefined) {
      sortedObj[key] = obj[key];
    }
  });

  remainingKeys.forEach((key) => {
    sortedObj[key] = obj[key];
  });

  return sortedObj;
};
